import { PostAbility } from '../interfaces/api_ability.interfaces';

const DEFAULT_COLOR_ABILITY: string = '#DDAA88';

export const DEFAULT_POST_ABILITY: PostAbility = { siteId: '', name: '', color: DEFAULT_COLOR_ABILITY, users: [] };